import { KeyboardArrowRight } from '@mui/icons-material';
import { styled, TableCell as MuiTableCell, TableRow as MuiTableRow } from '@mui/material';

export const StyledTableRow = styled(MuiTableRow, {
  shouldForwardProp: (prop) => prop !== 'hasInnerTable' && prop !== 'isClickable',
})<{ hasInnerTable: boolean | undefined; isClickable?: boolean }>(({ hasInnerTable, isClickable, theme }) => {
  const stripedBackground = theme.palette.background.default;
  const stripeSelector = hasInnerTable ? '&:nth-of-type(4n-1)' : '&:nth-of-type(even)';
  const stripeSelectorWithoutAmpersand = stripeSelector.startsWith('&') ? stripeSelector.slice(1) : stripeSelector;
  const stripeHoverSelector = hasInnerTable ? '&:nth-of-type(4n-1):hover' : '&:nth-of-type(even):hover';

  return {
    cursor: isClickable ? 'pointer' : 'default',
    [stripeSelector]: {
      backgroundColor: stripedBackground,
    },
    ...(isClickable
      ? {}
      : {
          '&:hover': {
            backgroundColor: 'transparent',
          },
          [stripeHoverSelector]: {
            backgroundColor: stripedBackground,
          },
          '&.MuiTableRow-hover:hover': {
            backgroundColor: 'transparent',
          },
          [`&.MuiTableRow-hover${stripeSelectorWithoutAmpersand}:hover`]: {
            backgroundColor: stripedBackground,
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.action.selected,
          },
        }),
  };
});

export const CollapseButton = styled(KeyboardArrowRight, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ open }: { open: boolean }) => ({
  cursor: 'pointer',
  transform: `rotate(${open ? '90deg' : '0'})`,
  transition: 'transform 0.1s ease',
}));

export const CollapseCell = styled(MuiTableCell)(() => ({
  paddingBottom: 0,
  paddingTop: 0,
  borderBottom: 0,
  height: 'auto',
}));

export const DragCell = styled(MuiTableCell)(() => ({
  cursor: 'move !important',
}));

export const StyledTableCell = styled(MuiTableCell)(() => ({
  paddingTop: 0,
  paddingBottom: 0,
  whiteSpace: 'nowrap',
  padding: 0,
}));

export const MetaCellContent = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const EditButtonsWrapper = styled('div')(() => ({
  display: 'flex',
}));
